import moment from "moment";
import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { IoMdCalendar } from "react-icons/io";
import { diffTime } from "../../utils/diffTime";

function ModalDetailAppointment({t, show, closeModal, infoCita, setInfoCita}){
    const handleCloseInfo = () => {
        setInfoCita(null)
        closeModal(false)
    }
    const [dataDoctor,setDataDoctor] = useState(null)
    const [dataPaciente,setDataPaciente] = useState(null)
    //console.log(infoCita.dataVideoCallList)

    useEffect(() => {
        if(infoCita){
            if(infoCita.dataVideoCallList.length > 0){
                let d= infoCita.dataVideoCallList.filter(e=>e.userType === "Doctor")
                let p= infoCita.dataVideoCallList.filter(e=>e.userType === "Patient")
    
                if(d.length > 0){
                    let dObj = {
                        inicia: d[0].startVideoCall,
                        termina: d[0].finishVideoCall,
                    }
                    setDataDoctor(dObj)
                }else{
                    setDataDoctor(null)
                }
                if(p.length > 0){
                    let pObj = {
                        inicia: p[0].startVideoCall,
                        termina: p[0].finishVideoCall,
                    }
                    setDataPaciente(pObj)
                }else{
                    setDataPaciente(null)
                }
            }else{
                setDataDoctor(null)
                setDataPaciente(null)
            }
        }        
    }, [infoCita])

    return (
        <Modal show={show} onHide={handleCloseInfo} size="lg">
                <Modal.Body>
                    {infoCita && 
                        <Row>
                            <Col xs="12" md="6">
                                <h4 className="color-blue-dark">{t('paciente_informacion')}</h4>
                                <h6 className="text-dark-50 mb-4">{infoCita && `${infoCita.patientDTO.name} ${infoCita?.patientDTO?.middleName ?? ''} ${infoCita.patientDTO.lastName} ${infoCita?.patientDTO?.seccondSurname ?? ''}`}</h6>
                                <Row className="font-size-09rem">                                                                
                                    <Col xs="12" md="12"><label className="mb-2"><strong>Cuenta: </strong>{infoCita.patientDTO && infoCita.patientDTO.account?.name}</label></Col>                                
                                </Row>
                            </Col>
                            <Col xs="12" md="6">
                                <h4 className="color-blue-dark mb-2">{t('informacion_cita')}</h4>
                                <Row className="align-items-center">
                                    <Col xs="12" md="12">
                                        {infoCita && <h6 className="mb-1 text-dark-50 font-weight-bold">{`${infoCita.scheduleDTO.doctor?.name} ${infoCita.scheduleDTO.doctor?.lastName}`}</h6>}
                                        {infoCita && <label className="mb-0 d-block text-dark-50 font-weight-light font-size-16rem">{infoCita.speciality.name}</label>}                                    
                                        
                                        <label><IoMdCalendar /> {moment(infoCita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format('DD MMMM YYYY, HH:mm')} hrs</label>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs="12" md="12">
                                <h4 className="color-blue-dark">Detalles</h4>
                                <Row className="font-size-09rem">                                                                
                                    <Col xs="12" md="12">
                                        <ul className="list-inline">
                                            <li><strong>Duración:</strong></li>
                                            <li className="list-inline-item mr-5">
                                                Doctor: 
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <table className="table table-duration table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Comenzó</th>
                                                                    <th>Terminó</th>
                                                                    <th>Duración</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{dataDoctor?.inicia ? moment(dataDoctor?.inicia, "YYYY-MM-DDTHH:mm:ss").format("HH:mm:ss") : '-'}</td>
                                                                    <td>{dataDoctor?.termina ? moment(dataDoctor?.termina, "YYYY-MM-DDTHH:mm:ss").format("HH:mm:ss") : '-'}</td>
                                                                    <td>{diffTime(dataDoctor?.inicia, dataDoctor?.termina, "minutes")}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="list-inline-item">
                                                Paciente: 
                                                <ul className="list-unstyled">
                                                    <li>
                                                        <table className="table table-duration table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Comenzó</th>
                                                                    <th>Terminó</th>
                                                                    <th>Duración</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{dataPaciente?.inicia ? moment(dataPaciente?.inicia, "YYYY-MM-DDTHH:mm:ss").format("HH:mm:ss") : '-'}</td>
                                                                    <td>{dataPaciente?.termina ? moment(dataPaciente?.termina, "YYYY-MM-DDTHH:mm:ss").format("HH:mm:ss") : '-'}</td>
                                                                    <td>{diffTime(dataPaciente?.inicia, dataPaciente?.termina, "minutes")}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </Col>                                
                                </Row>
                            </Col>
                        </Row>
                    }

                    <Row className="my-3">
                        <Col className="text-right">
                            <Button variant="secondary" onClick={handleCloseInfo}>Aceptar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
    )
}

export default withTranslation()(ModalDetailAppointment)